import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

export const INITIAL_STATE = {
  isReady: false,

  user: {},

  isUpdating: false,
  updateSuccess: false,
  updateError: false,

  isUpdatingImage: false,
  imageUpdateSuccess: false,
  imageUpdateError: false,

  isDeleting: false,
  deleteError: null,

  isUpdatingPreferences: false,
  preferencesUpdateSuccess: false,
  preferencesUpdateError: false,
}

export const INIT = 'profile/INIT'

export const UPDATE = 'profile/UPDATE'
export const UPDATED = 'profile/UPDATED'
export const UPDATE_ERROR = 'profile/UPDATE_ERROR'

export const UPDATE_IMAGE = 'profile/UPDATE_IMAGE'
export const IMAGE_UPDATED = 'profile/IMAGE_UPDATED'
export const IMAGE_UPDATE_ERROR = 'profile/IMAGE_UPDATE_ERROR'

export const DELETE = 'profile/DELETE'
export const DELETED = 'profile/DELETED'
export const DELETE_ERROR = 'profile/DELETE_ERROR'

export const UPDATE_NEWSLETTER_SUBSCRIPTION = 'profile/UPDATE_NEWSLETTER_SUBSCRIPTION'
export const NEWSLETTER_SUBSCRIPTION_UPDATED = 'profile/NEWSLETTER_SUBSCRIPTION_UPDATED'
export const UPDATE_PARTNER_SUBSCRIPTION = 'profile/UPDATE_PARTNER_SUBSCRIPTION'
export const PARTNER_SUBSCRIPTION_UPDATED = 'profile/PARTNER_SUBSCRIPTION_UPDATED'
export const PREFERENCES_UPDATE_ERROR = 'profile/PREFERENCES_UPDATE_ERROR'

export const CLEAR = 'profile/CLEAR'

// init :: User -> Action
export const init = user => ({
  type: INIT,
  user,
})

// updateImage :: (File|Null) -> Action.UPDATE_IMAGE
export const updateImage = file => ({
  type: UPDATE_IMAGE,
  file,
})

// imageUpdated :: User -> Action.IMAGE_UPDATED
export const imageUpdated = user => ({
  type: IMAGE_UPDATED,
  user,
})

// imageUpdateError :: () -> Action.IMAGE_UPDATE_ERROR
export const imageUpdateError = always({
  type: IMAGE_UPDATE_ERROR,
})

// updateUser :: (String, String, String, String, String, String, String) -> Action.UPDATE
export const updateUser = (
  gender,
  firstname,
  lastname,
  nickname,
  country,
  locale,
  email,
) => ({
  type: UPDATE,
  gender,
  firstname,
  lastname,
  nickname,
  country,
  locale,
  email,
})

// updated :: User -> Action.UPDATED
export const updated = user => ({
  type: UPDATED,
  user,
})

// updateError :: () -> Action.UPDATE_ERROR
export const updateError = always({
  type: UPDATE_ERROR,
})

// deleteUser :: () -> Action.DELETE
export const deleteUser = always({ type: DELETE })

// deleted :: () -> Action.DELETED
export const deleted = always({ type: DELETED })

// deleteError :: Error -> Action.DELETE_ERROR
export const deleteError = error => ({
  type: DELETE_ERROR,
  error,
})

// updateNewsletterSubscription :: Boolean -> Action.UPDATE_NEWSLETTER_SUBSCRIPTION
export const updateNewsletterSubscription = newsletterSubscription => ({
  type: UPDATE_NEWSLETTER_SUBSCRIPTION,
  newsletterSubscription,
})

// newsletterSubscriptionUpdated :: User -> Action.NEWSLETTER_SUBSCRIPTION_UPDATED
export const newsletterSubscriptionUpdated = user => ({
  type: NEWSLETTER_SUBSCRIPTION_UPDATED,
  user,
})

// updatePartnerSubscription :: Boolean -> Action.UPDATE_PARTNER_SUBSCRIPTION
export const updatePartnerSubscription = partnerSubscription => ({
  type: UPDATE_PARTNER_SUBSCRIPTION,
  partnerSubscription,
})

// partnerSubscriptionUpdated :: User -> Action.PARTNER_SUBSCRIPTION_UPDATED
export const partnerSubscriptionUpdated = user => ({
  type: PARTNER_SUBSCRIPTION_UPDATED,
  user,
})

// preferencesUpdateError :: () -> Action.PREFERENCES_UPDATE_ERROR
export const preferencesUpdateError = always({
  type: PREFERENCES_UPDATE_ERROR,
})

// clear :: () -> Action.CLEAR
export const clear = always({
  type: CLEAR,
})

export default createReducer(INITIAL_STATE, {
  [INIT]: (state, { user }) => ({
    ...INITIAL_STATE,
    isReady: true,
    user,
  }),
  [UPDATE]: state => ({
    ...state,
    isUpdating: true,
    updateSuccess: false,
    updateError: false,
  }),
  [UPDATED]: (state, { user }) => ({
    ...state,
    isUpdating: false,
    updateSuccess: true,
    updateError: false,
    user,
  }),
  [UPDATE_ERROR]: state => ({
    ...state,
    isUpdating: false,
    updateSuccess: false,
    updateError: true,
  }),
  [UPDATE_IMAGE]: state => ({
    ...state,
    isUpdatingImage: true,
    imageUpdateSuccess: false,
    imageUpdateError: false,
  }),
  [IMAGE_UPDATED]: (state, { user }) => ({
    ...state,
    isUpdatingImage: false,
    imageUpdateSuccess: true,
    imageUpdateError: false,
    user,
  }),
  [IMAGE_UPDATE_ERROR]: state => ({
    ...state,
    isUpdatingImage: false,
    imageUpdateSuccess: false,
    imageUpdateError: true,
  }),
  [DELETE]: state => ({
    ...state,
    isDeleting: true,
    deleteError: null,
  }),
  [DELETED]: state => ({
    ...state,
    isDeleting: false,
    deleteError: null,
  }),
  [DELETE_ERROR]: (state, { error }) => ({
    ...state,
    isDeleting: false,
    deleteError: error,
  }),
  [UPDATE_NEWSLETTER_SUBSCRIPTION]: state => ({
    ...state,
    isUpdatingPreferences: true,
    preferencesUpdateSuccess: false,
    preferencesUpdateError: false,
  }),
  [NEWSLETTER_SUBSCRIPTION_UPDATED]: (state, { user }) => ({
    ...state,
    isUpdatingPreferences: false,
    preferencesUpdateSuccess: true,
    preferencesUpdateError: false,
    user,
  }),
  [UPDATE_PARTNER_SUBSCRIPTION]: state => ({
    ...state,
    isUpdatingPreferences: true,
    preferencesUpdateSuccess: false,
    preferencesUpdateError: false,
  }),
  [PARTNER_SUBSCRIPTION_UPDATED]: (state, { user }) => ({
    ...state,
    isUpdatingPreferences: false,
    preferencesUpdateSuccess: true,
    preferencesUpdateError: false,
    user,
  }),
  [PREFERENCES_UPDATE_ERROR]: state => ({
    ...state,
    isUpdatingPreferences: false,
    preferencesUpdateSuccess: false,
    preferencesUpdateError: true,
  }),
  [CLEAR]: always(INITIAL_STATE),
})
